"use client"

import {
  Carousel,
  CarouselContent,
  CarouselItem
} from "@/components/ui/carousel"
import {
  cn
} from "@/lib/utils"
import Autoplay from "embla-carousel-autoplay"
import React, {
  useEffect,
  useState
} from "react"

const TopCarousel = ({
  cmsBannerItems, isMobile 
}) => {
  const [api, setApi] = useState()
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (!api) { return }

    api.on("select", () => {
      setActiveIndex(api.selectedScrollSnap())
    })
  }, [api])

  const handleIndicatorClick = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };

  return (
    <Carousel className='w-full'
      plugins={[
        Autoplay({
          delay: 5000,
        }),

      ]}
      opts={{
        loop: true,
      }}
      setApi={setApi}
    >
      <CarouselContent className='-ml-0 w-full'
      >
        {cmsBannerItems?.map((item, index) => (
          <CarouselItem key={item.id} className='w-full pl-0'>
            {item.component}
          </CarouselItem>
        ))}
      </CarouselContent>

      <div className='absolute bottom-2 flex w-full items-center justify-center'>
        {
          Array.from({
            length: cmsBannerItems.length 
          }, (_, index) => (
            <div
              key={index}
              className={cn("text-0 mx-1.5 inline-block h-[3px] w-10 cursor-pointer rounded-none bg-white text-center opacity-20", {
                "opacity-100": index === activeIndex,
              })}
              onClick={() => handleIndicatorClick(index)}
            />
          ))
        }
      </div>
    </Carousel>
  )
}

export default TopCarousel
